import { DefaultPlan, ICustomerAppreciationDiscount, IPlan } from '../../types/Plan';
import { DefaultPlanSku, IPlanSku } from '../../types/PlanSku';
import { DeviceType } from '../../types/Device';

export interface IPlanHooks {
    plans: IPlan[];
    discountMap: ICustomerAppreciationOptionsMap;
    HandleLoadPlans: () => void;
    GetLinePrice: (plan: IPlan, lineNumber: number) => number;
    CalcMultiLineDiscount: (plan: IPlan, lineNumber: number) => number;
    GetPlanDisplayName: (plan: IPlan) => string;
    HasCustomerAppreciationDiscount: (planSelection: IPlanSelection) => boolean;
    GetCustomerAppreciationDiscountAmountString: (planSelection: IPlanSelection) => string;
    GetDiscountByName: (plan: IPlan, name: string) => ICustomerAppreciationDiscount | undefined;
    GetPlanSku: (
        planId: string,
        deviceType: DeviceType,
        lineNumber: number,
        onSuccess: (planSku: IPlanSku) => void,
        onFailure: () => void
    ) => void;
}

export interface IPlanSelection {
    plan: IPlan;
    customerAppreciationDiscount: ICustomerAppreciationDiscount | undefined;
    linePrice: number;
    planDisplayName: string;
    planSku: IPlanSku;
}

export const DefaultPlanSelection = (): IPlanSelection => {
    return {
        customerAppreciationDiscount: undefined,
        plan: DefaultPlan(),
        linePrice: 0,
        planDisplayName: '',
        planSku: DefaultPlanSku()
    };
};

export type ICustomerAppreciationOptionsMap = { [key: number]: string[] };

export const DefaultCustomerAppreciationOptionsMap = (): ICustomerAppreciationOptionsMap => {
    return {};
};
